// @flow

import isNil from 'lodash/isNil'
import ApiObject from '../ApiObject'

import CurrencyUtils from '../../utils/CurrencyUtils'

export default class UserAccount extends ApiObject {

  amount: number

  postJsonAssignation(data: Object) {
    super.postJsonAssignation(data)
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/user/UserAccount.js